<article class="ul-card narrow">
  <comp-card-header>
    <span headline>{{ 'manufacturer.manufacturerDetails' | translate }}</span>
    @if (!editing()) {
      <ng-container action-items>
        <div class="prime-action-bar">
          <button comp-button type="button" (click)="edit()">
            <i comp-icon>edit</i>
            <span>{{ 'general.edit' | translate }}</span>
          </button>
        </div>
      </ng-container>
    }
  </comp-card-header>
  @if (firstVisit()) {
    <p>{{ 'manufacturer.createNewMessage' | translate }}</p>
  }
  @if (!editing()) {
    @if (manufacturer(); as manufacturer) {
      <div class="manufacturer-details">
        <div class="manufacturer-detail label">
          {{ 'model.manufacturer.properties.brandName' | translate }}:
        </div>
        <div class="manufacturer-detail">
          {{ manufacturer.brandName }}
        </div>
        <div class="manufacturer-detail label">
          {{ 'model.manufacturer.properties.legalEntityName' | translate }}:
        </div>
        <div class="manufacturer-detail">
          {{ manufacturer.legalEntityName }}
        </div>
        <div class="manufacturer-detail label">
          {{ 'model.manufacturer.properties.productContact' | translate }}:
        </div>
        <div class="manufacturer-detail">{{ manufacturer.productContact }}</div>
        <div class="manufacturer-detail label">
          {{ 'model.manufacturer.properties.productContactLocation' | translate }}:
        </div>
        <div class="manufacturer-detail">
          {{ manufacturer.productContactLocation }}
        </div>
        <div class="manufacturer-detail label">
          {{ 'model.manufacturer.properties.productContactEmail' | translate }}:
        </div>
        <div class="manufacturer-detail">
          @if (manufacturer.productContactEmail) {
            <a href="mailto:{{ manufacturer.productContactEmail }}">{{
              manufacturer.productContactEmail
            }}</a>
          }
        </div>
        <div class="manufacturer-detail label">
          {{ 'model.manufacturer.properties.productContactPhone' | translate }}:
        </div>
        <div class="manufacturer-detail">
          {{ manufacturer.productContactPhone }}
        </div>
      </div>
    } @else {
      <mat-spinner></mat-spinner>
    }
  } @else {
    <form class="ul-form product-edit-form" [formRoot]="editForm" (keydown.escape)="cancel()">
      <div class="manufacturer-details-edit">
        <div class="manufacturer-detail">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{ 'model.manufacturer.properties.brandName' | translate }}</mat-label>
            <input
              compAutofocus
              type="text"
              #brandNameInput
              matInput
              [formField]="editForm.brandName"
            />
            @if (editForm.brandName().errors().length > 0) {
              <mat-error>
                {{ 'general.validation.required' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="manufacturer-detail">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{ 'model.manufacturer.properties.legalEntityName' | translate }}</mat-label>
            <input type="text" matInput [formField]="editForm.legalEntityName" />
            @if (editForm.legalEntityName().errors().length > 0) {
              <mat-error>
                {{ 'general.validation.required' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="manufacturer-detail">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{ 'model.manufacturer.properties.productContact' | translate }}</mat-label>
            <input type="text" matInput [formField]="editForm.productContact" />
          </mat-form-field>
        </div>
        <div class="manufacturer-detail">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{
              'model.manufacturer.properties.productContactLocation' | translate
            }}</mat-label>
            <input type="text" matInput [formField]="editForm.productContactLocation" />
          </mat-form-field>
        </div>
        <div class="manufacturer-detail">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{
              'model.manufacturer.properties.productContactEmail' | translate
            }}</mat-label>
            <input type="email" matInput [formField]="editForm.productContactEmail" />
            @if (editForm.productContactEmail().errors().length > 0) {
              <mat-error>
                {{ 'general.validation.mail' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="manufacturer-detail">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{
              'model.manufacturer.properties.productContactPhone' | translate
            }}</mat-label>
            <input type="tel" matInput [formField]="editForm.productContactPhone" />
            @if (editForm.productContactPhone().errors().length > 0) {
              <mat-error>
                {{ 'general.validation.tel' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="button-bar">
        @if (!firstVisit()) {
          <button comp-button="secondary" type="button" (click)="cancel()">
            {{ 'general.cancel' | translate }}
          </button>
        }
        <button comp-button type="submit">
          {{ 'general.save' | translate }}
        </button>
      </div>
    </form>
  }
</article>
